import React, { Component } from 'react';
import './index.css';
//var FontAwesome = require('react-fontawesome');

class About extends Component {
render() {
    return (
      <div>
        <h1>About</h1>

      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// src/about.js